import { Menu, MenuItem } from "@mui/material";
import "./MaterialActionsOverlay.scss";
import { useGlobalState } from "../../MeetContext/MeetContext";

export interface MenuItemType {
    icon?: string;
    label: string;
    onClick: () => void;
}

interface ActionsOverlayProps {
    anchorEl: HTMLElement | null;
    open: boolean;
    handleClose: () => void;
    menuItems: MenuItemType[];
    actionsHeight: string;
    position: number | "center" | "left" | "right";
    verticalPosition?: number| "top" | "bottom" | "center";
    module?: string;
}

const MaterialActionsOverlay: React.FC<ActionsOverlayProps> = ({ module, anchorEl, open, handleClose, menuItems, actionsHeight, position, verticalPosition }) => {
const {isParticipantsGridViewVisible} = useGlobalState();
    return (
        <Menu
            id="action-menu"
            MenuListProps={{
                "aria-labelledby": "long-button",
                disablePadding: true,
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
                vertical: verticalPosition || 'top',
                horizontal: position,
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: position,
            }}
            sx={{
                '& .MuiPaper-root': {
                    borderRadius: '5px',
                    boxShadow: '-10px 10px 15px 0.2px rgba(0, 0, 0, 0.05)',
                    ...(module && module === 'meetControls' && {top: isParticipantsGridViewVisible ? 'calc(100% - 240px) !important' : 'calc(100% - 202px) !important'})
                },
            }}
        >
            <div className="materialActionsOverlayContainer" style={{ height: actionsHeight }}>
                {menuItems?.map((item, index) => (
                    <MenuItem key={index} className="materialActionItem" onClick={item.onClick}>
                        {(item.icon) && <img src={item.icon} alt={item.label} />}
                        <p className="materialActionLabel">{item.label}</p>
                    </MenuItem>
                ))}
            </div>
        </Menu>
    )
}

export default MaterialActionsOverlay;
